export function Import({ touch, desktop, isReponsiveImport = false }) {
    const isMobileView = window.matchMedia('(max-width: 1024px)').matches;
    const isTouchDevice = window.matchMedia('(pointer: coarse) and (hover: none)').matches;
    return isTouchDevice
        || (isReponsiveImport && isMobileView)
        ? touch : desktop;
}
